export default __webpack_public_path__ + "static/media/dark_4_placeholder.d4cab06c.jpg";